import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {getConversations} from '../../../store/data/dataSelectors';
import {updateSizeAction} from '../../../store/data/localPreferences/localPreferencesActions';
import {getSizes} from '../../../store/data/localPreferences/localPreferencesSelectors';
import {getIsUserVisitor, getUser} from '../../../store/data/teammates/teammatesSelectors';
import {getHasVisitorExperienceV3} from '../../../store/featureFlags/featureFlagsSelectors';
import {navigateInboxesAsyncAction} from '../../../store/panels/inboxes/inboxesPanelActions';
import {InboxesParameters} from '../../../store/panels/inboxes/parameters/inboxesParameters';
import {InboxesPanelId} from '../../../store/panels/panelStateBase';
import {VisitorConversations} from './visitorConversations';

/*
 * Props.
 */

interface VisitorConversationsContainerProps {
  panelId: InboxesPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<VisitorConversationsContainerProps>()(() => ({
  user: getUser,
  isUserVisitor: getIsUserVisitor,
  hasVisitorExperienceV3: getHasVisitorExperienceV3,
  sizes: getSizes,
  conversations: getConversations,
}));

const mapDispatchToProps = makeMapDispatchToProps<VisitorConversationsContainerProps>()(({panelId}) => ({
  onParametersChange: (parameters: InboxesParameters) => navigateInboxesAsyncAction(panelId, parameters),
  updateSize: updateSizeAction,
}));

export const VisitorConversationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisitorConversations);
